module.exports = __webpack_public_path__ + "static/media/casestudies.abe331a3.png";